import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';

let SampleResults: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Sample Results">
        <Field input={<TextOutput />} name="Results.TotalSampleDryMass" emph />
        <Field input={<TextOutput />} name="Results.OversizeWet" emph />
        <Field input={<TextOutput />} name="Results.OversizeDry" emph />
      </ListFieldSection>
    </>
  );
};

SampleResults = withInjectedProps(SampleResults);

export { SampleResults };
export default SampleResults;
